module.exports = __webpack_public_path__ + "img/img7.4ccd5975.svg";